import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import { RestReadRequest } from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { InvoiceService } from "../services/InvoiceService.js";
export class OpenInvoiceLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, searchCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.searchCode = searchCode;
    let resetCriteria = new RestReadRequest();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let invoiceLookupCriteria = new RestReadRequest();
    invoiceLookupCriteria.companyCode = this.companyCode;
    invoiceLookupCriteria.code = this.searchCode;
    let newCriteria = new RestReadRequest();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = OpenInvoiceLookupCriteraHandler(
      companyCode,
      invoiceLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      invoiceLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getInvoiceStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("CustomerCode", "customerCode", 0, false); //3
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //3

    this.addColumnDefinition(
      " CustomerPO#",
      "customerPurchaseOrderNumber",
      0,
      false
    ); //1

    this.addColumnDefinition("InvoiceDate", "invoiceDate", 0, false); //3
    this.addColumnDefinition("InvoiceQty", "invoiceQuantity", 0, false); //3
    this.addColumnDefinition("PaidAmt", "paidAmount", 0, false); //3
  }
  openInvoiceList = (lookup_dialog, pageNumber, searchCriteria) => {
    let inv_criteria = new RestReadRequest(); //To be fetched from CriteriaHandler
    inv_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      inv_criteria.code = searchCriteria.code;
      if (!isEmptyString(this.searchCode)) {
        inv_criteria.code = this.searchCode;
      }
    }
    InvoiceService.getOpenInvoicesForAccountReceivable(
      inv_criteria,
      (response) => this.openInvoiceListResponse(response, lookup_dialog),
      this.loadInvoiceListError
    );
  };
  openInvoiceListResponse = (response, lookup_dialog) => {
    let invList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.invoicePageList) &&
      !isEmptyArray(response.data.invoicePageList.invoices)
    ) {
      invList = response.data.invoicePageList.invoices;
      totalCount = response.data.invoicePageList.totalCount;
      currentPageNumber = response.data.invoicePageList.currentPage;
      pageSize = response.data.invoicePageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = invList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadInvoiceListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.invoiceNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.code = filterText;
        this.searchCriteria = new RestReadRequest();
      }
    }
    if (lookup_dialog != null) {
      this.openInvoiceList(lookup_dialog, pageNumber, search);
    }
  }
}
const OpenInvoiceLookupCriteraHandler = (
  companyCode,
  invoiceLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new RestReadRequest(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new RestReadRequest();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customercode"
                  name="code"
                  onChange={this.onChange}
                  value={searchCriteria.code}
                />
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
